import React from 'react';
import { TableRow, TableCell, Checkbox, IconButton, Typography, Avatar, Chip } from '@mui/material';
import { MoreVert as MoreIcon } from '@mui/icons-material';
import { useTranslation } from 'react-i18next';
import dayjs from "dayjs";

const PostsTableRow = ({
    item,
    index,
    page,
    perPage,
    isSelected,
    onRowCheckboxClick,
    onMenuOpen,
}) => {
    const { i18n } = useTranslation();
    const lng = i18n.language || "en";
    const isArabic = lng.startsWith("ar");

    const getStatusColor = (status) => {
        switch (status) {
            case 'published': return 'success';
            case 'draft': return 'default';
            case 'scheduled': return 'warning';
            default: return 'default';
        }
    };

    return (
        <TableRow hover selected={isSelected}>
            <TableCell padding="checkbox">
                <Checkbox
                    checked={isSelected}
                    onChange={(event) => onRowCheckboxClick(event, item.id)}
                />
            </TableCell>

            <TableCell>{index + 1 + (page - 1) * perPage}</TableCell>

            <TableCell align="center">
                <Avatar
                    variant="rounded"
                    src={item.featured_image || ""}
                    alt={item.title?.en}
                    sx={{ width: 50, height: 50, margin: 'auto' }}
                >
                    {item.title?.en?.charAt(0)}
                </Avatar>
            </TableCell>

            <TableCell align="left">
                <Typography variant="body2">{item.title?.en || '-'}</Typography>
            </TableCell>

            <TableCell align="right">
                <Typography variant="body2">{item.title?.ar || '-'}</Typography>
            </TableCell>

            <TableCell align="center">
                <Chip
                    label={item.category?.name?.[lng] || '-'}
                    size="small"
                    variant="outlined"
                />
            </TableCell>

            <TableCell align="center">
                <Chip
                    label={item.is_published ? (isArabic ? "نشر" : "Published") : (isArabic ? "مسودة" : "Draft")}
                    color={getStatusColor(item.is_published)}
                    size="small"
                />
            </TableCell>

            <TableCell align="center">
                {dayjs(item.created_at).format("YYYY-MM-DD")}
            </TableCell>

            <TableCell align="center">
                <IconButton onClick={(e) => onMenuOpen(e, item)}>
                    <MoreIcon />
                </IconButton>
            </TableCell>
        </TableRow>
    );
};

export default PostsTableRow;
